import { createContext, useContext } from 'react';
import type { Rol, Usuario } from '../api/tipos';

export interface UsuarioDev {
  oid: string;
  nombre: string;
  correo: string;
  roles: Rol[];
}

export interface Sesion {
  modo: 'entra' | 'dev';
  usuario: Usuario;
  roles: Rol[];
  cerrarSesion: () => void;
  /** Solo en modo dev: usuarios de prueba y cambio de usuario. */
  usuariosDev?: UsuarioDev[];
  cambiarUsuarioDev?: (oid: string) => void;
}

export const ContextoSesion = createContext<Sesion | null>(null);

export function useSesion(): Sesion {
  const s = useContext(ContextoSesion);
  if (!s) throw new Error('useSesion debe usarse dentro del proveedor de autenticación');
  return s;
}
